import { combineReducers } from '@reduxjs/toolkit';
import contractConfigReducer from './contractConfig';
import rewardDistributionDataReducer from './rewardDistributionData';

const rawVestaMinterReducer = combineReducers({
  config: contractConfigReducer,
  rewardDistributionData: rewardDistributionDataReducer
  //   snapshots: snapshotsReducer
});

export default rawVestaMinterReducer;
